// extracted by mini-css-extract-plugin
module.exports = {"resultsCounter":"result-counter_resultsCounter__4v0hs","category":"result-counter_category___RBfX"};